import React, { useState } from 'react';

export default function GlobalCheckoutBanner({ session, onCheckout }) {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    setLoading(true);
    await onCheckout();
    setLoading(false);
  };

  return (
    <div style={{
      width: '100%',
      background: 'linear-gradient(145deg, #05070a 0%, #0a0f14 100%)',
      borderTop: '1px solid #ffca28',
      borderBottom: '1px solid #ffca28',
      padding: '60px 20px',
      boxSizing: 'border-box',
      textAlign: 'center',
      boxShadow: '0 0 30px rgba(255, 202, 40, 0.1)',
      marginTop: '40px'
    }}>
      <div style={{ maxWidth: '800px', margin: '0 auto' }}>
        
        <h2 style={{ 
          color: '#ffffff', 
          fontSize: '2rem', 
          textTransform: 'uppercase', 
          letterSpacing: '2px', 
          margin: '0 0 20px 0' 
        }}>
          You Only Get One Physical Vehicle. <br/>
          <span style={{ color: '#00d4ff' }}>Why Are You Driving It Blind?</span>
        </h2>
        
        <p style={{ color: '#8b949e', fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '20px' }}>
          Most people will spend their entire lives scrolling for answers without ever once looking up at the actual sky. They live, breathe, and die operating under a 2,000-year-old software glitch. 
        </p>

        <p style={{ color: '#c9d1d9', fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '35px' }}>
          I didn't just find the bug—I cracked the exact astronomical, calendrical, and bio-hacking codes to fix it. Divinity isn't a religion; it is absolute, unapologetic biomechanical alignment with the cosmos. Stop endlessly searching and reclaim your true celestial identity.
        </p>

        <button 
          onClick={handleClick}
          disabled={loading}
          style={{
            backgroundColor: loading ? '#30363d' : '#ffca28',
            color: loading ? '#8b949e' : '#0d1117',
            border: 'none',
            padding: '18px 45px',
            fontSize: '1.2rem',
            fontWeight: 'bold',
            textTransform: 'uppercase',
            borderRadius: '4px',
            cursor: loading ? 'not-allowed' : 'pointer',
            boxShadow: '0 0 20px rgba(255, 202, 40, 0.4)',
            transition: 'all 0.3s ease'
          }}
        >
          {loading ? "⚡ INITIALIZING GATEWAY..." : "Unlock Your Astro-Somatic Blueprint — $99"}
        </button>

        <p style={{ color: '#484f58', fontSize: '0.85rem', marginTop: '20px', fontStyle: 'italic' }}>
          Secure your master key to the 13-Sign Matrix. Instant access upon alignment.
        </p>
      </div>
    </div>
  );
}